import "./CustomButton.css";

const CustomButton = ({
  children,
  variant = "primary",
  onClick = () => {},
  className = "",
  as: Component,
  to,
  ...props
}) => {
  const containerClass = `custom-button-wrapper variant-${variant} ${className}`;

  const content = (
    <div className="button-content-wrapper">
      <span className="button-text">
        <span className="text-original">{children}</span>
        <span className="text-hover">{children}</span>
      </span>
    </div>
  );

  if (Component || to) {
    const LinkComponent = Component || "a";
    return (
      <LinkComponent
        className={containerClass}
        to={to}
        onClick={onClick}
        {...props}
      >
        {content}
      </LinkComponent>
    );
  }

  return (
    <button className={containerClass} onClick={onClick} {...props}>
      {content}
    </button>
  );
};

export default CustomButton;
